/**
 * Logistics Call-Offs Page
 *
 * Restricted view for logistics company users: confirmed, dispatched and
 * delivered call-offs from linked customers. The list itself is
 * LogisticsCallOffsView.
 */
import { Truck } from 'lucide-react';
import LogisticsCallOffsView from '../components/call-off/logistics/LogisticsCallOffsView';

export default function LogisticsCallOffs() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Truck className="h-6 w-6" />
          Logistics Call-Offs
        </h1>
        <p className="text-muted-foreground">
          Supplier Confirmed, Dispatched and Delivered call-offs from the customers you carry for
        </p>
      </div>
      <LogisticsCallOffsView />
    </div>
  );
}
